// report_status에 따른 아이콘 색상과 툴팁을 반환하는 함수
export const getReportStatusInfo = (status) => {
  switch (status) {
    case 0:
      return { color: '!bg-gray-400', textColor: 'text-white', tooltip: '리포트 없음' };
    case 100:
      return { color: '!bg-yellow-500', textColor: 'text-gray-900', tooltip: '생성 요청됨' };
    case 101:
      return { color: '!bg-orange-500', textColor: 'text-white', tooltip: '생성 중' };
    case 102:
      return { color: '!bg-red-500', textColor: 'text-white', tooltip: '생성 오류' };
    case 150:
      return { color: '!bg-purple-500', textColor: 'text-white', tooltip: '편집 중' };
    case 200:
    case 998:
      return { color: '!bg-blue-500', textColor: 'text-white', tooltip: '준비 완료(미확정)' };
    case 999:
      return { color: '!bg-primary', textColor: 'text-white', tooltip: '확정 완료' };
    default:
      return { color: '!bg-gray-400', textColor: 'text-white', tooltip: '상태 불명' };
  }
};

// 날짜 포맷팅 함수
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}.${day}`;
};

// 날짜와 시간을 초단위까지 포맷팅하는 함수
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};

// 테스트 상태 정보 가져오기
export const getTestStatusInfo = (exam) => {
  if (!exam) return { badge: '미응시', color: 'bg-gray-100 text-gray-600' };
  
  const status = exam.exam_status;
  const hasResult = (exam.correct_count || 0) + (exam.wrong_count || 0) > 0;
  
  if (status === 999) {
    return { badge: '완료', color: 'bg-green-100 text-green-800' };
  } else if (status >= 200 && status < 999) {
    if (hasResult) {
      return { badge: '채점중', color: 'bg-blue-100 text-blue-800' };
    } else {
      return { badge: '진행중', color: 'bg-yellow-100 text-yellow-800' };
    }
  } else {
    return { badge: '미응시', color: 'bg-gray-100 text-gray-600' };
  }
};

// 결과맵 상태별 색상 가져오기
export const getStatusColor = (status) => {
  switch (status) {
    case 200: return 'bg-primary'; // 맞음
    case 201: return 'bg-[#B7E4CE] opacity-70'; // 맞을 가능성 높음
    case 100: return 'bg-danger'; // 틀림
    case 101: return 'bg-[#FDCECE] opacity-70'; // 틀릴 가능성 높음
    case 500: return 'bg-[#FAEECE]'; // 기타
    default: return 'bg-gray-200'; // 문제 없음
  }
};

// HTML 디코딩 함수
export const decodeHtml = (html) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}; 